import { createSlice } from '@reduxjs/toolkit'

export const featureToggleSlice = createSlice({
  name: 'featureToggle',
  initialState: {
    recommendDiscount: {
      enable: false,
      loaded: false,
    },
  },
  reducers: {
    setRecommendDiscountEnabled: (state, action) => {
      state.recommendDiscount = { enable: action.payload, loaded: true }
    },
  },
})

export const selectRecommendDiscountSetting = (state) =>
  state.featureToggle.recommendDiscount

export const { setRecommendDiscountEnabled } = featureToggleSlice.actions

export default featureToggleSlice.reducer
